const messages = {
  _default: field => `The ${field} value is not valid.`,
  after: (field, [target]) => `The ${field} must be after ${target}.`,
  alpha_dash: field =>
    `The ${field} may contain alpha-numeric characters as well as dashes and underscores.`,
  alpha_num: field => `Please use only letters and numbers.`,
  alpha_spaces: field =>
    `The ${field} may only contain alphabetic characters as well as spaces.`,
  alpha: field => `Please enter only letters.`,
  before: (field, [target]) => `The ${field} must be before ${target}.`,
  between: (field, [min, max]) =>
    `The ${field} must be between ${min} and ${max}.`,
  confirmed: field => `The ${field} confirmation does not match.`,
  credit_card: field => `The ${field} is invalid.`,
  date_between: (field, [min, max]) =>
    `The ${field} must be between ${min} and ${max}.`,
  date_format: (field, [format]) =>
    `The ${field} must be in the format ${format}.`,
  decimal: (field, [decimals] = ['*']) =>
    `The ${field} must be numeric and may contain ${
      decimals === '*' ? '' : decimals
    } decimal points.`,
  digits: (field, [length]) =>
    `Please enter only ${length} digit numbers.`,
  dimensions: (field, [width, height]) =>
    `The ${field} must be ${width} pixels by ${height} pixels.`,
  ext: field => `The ${field} must be a valid file.`,
  email: field => `Please enter a valid ${field}.`,
  image: field => `The ${field} must be an image.`,
  in: field => `The ${field} must be a valid value.`,
  ip: field => `Please enter a valid ${field}.`,
  max: (field, [length]) =>
    `The ${field} may not be greater than ${length} characters.`,
  max_value: (field, [max]) => `Please enter a number ${max} or less.`,
  mimes: field => `The ${field} must have a valid file type.`,
  min: (field, [length]) =>
    `The ${field} must be at least ${length} characters.`,
  min_value: (field, [min]) => `The ${field} must be ${min} or more.`,
  not_in: field => `The ${field} must be a valid value.`,
  numeric: field => `Please enter only numbers.`,
  regex: field => `The ${field} format is invalid.`,
  required: field => `Required field.`,
  size: (field, [size]) => `The ${field} must be less than ${size} KB.`,
  url: field => `Please enter a valid URL.`
}

export default messages